'use strict';

var React = require('react'),
    IconValueLeft = require('../Icon/IconValue/IconValueLeft'),
    RectIcon = require('../Icon/RectIcon'),
    _ = require('lodash');

var Checkbox = React.createClass({
  displayName: 'Checkbox',


  propTypes: {
    label: React.PropTypes.string,
    checked: React.PropTypes.oneOfType([React.PropTypes.bool, React.PropTypes.string]),
    isEnabled: React.PropTypes.bool,
    onChange: React.PropTypes.func,
    checkIcon: React.PropTypes.string,
    uncheckIcon: React.PropTypes.string,
    value: React.PropTypes.any,
    className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      checked: false,
      isEnabled: true,
      onChange: _.noop,
      checkIcon: "img/icoCheckboxChecked.png",
      uncheckIcon: "img/icoCheckboxUnChecked.png",
      value: ''
    };
  },

  getInitialState: function getInitialState() {
    return {
      checked: this.props.checked
    };
  },

  componentWillReceiveProps: function componentWillReceiveProps(props) {
    if (props.checked != undefined) {
      this.setState({ checked: props.checked });
    }
  },

  onCheckChange: function onCheckChange(e) {
    if (!this.props.isEnabled) {
      return;
    }

    this.setState({ checked: !this.state.checked });
    this.props.onChange(e, this.props.value, !this.state.checked);
  },

  keyDown: function keyDown(event) {
    //Check for space
    if (event.keyCode == 32) {
      this.onCheckChange(event);
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  },

  getValue: function getValue() {
    return this.props.value;
  },

  render: function render() {
    var classNames = _.concat(['checkbox'], this.props.className),
        icon = this.state.checked ? this.props.checkIcon : this.props.uncheckIcon;

    if (this.props.isEnabled) {
      classNames.push('clickable');
    } else {
      classNames.push('disabled');
    }

    return React.createElement(
      'div',
      { onClick: this.onCheckChange, className: classNames.join(' '), tabIndex: 0, onKeyDown: this.keyDown },
      React.createElement(
        IconValueLeft,
        { icon: icon },
        this.props.label ? this.props.label : this.props.children
      )
    );
  }

});

module.exports = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/Checkbox.js
// module id = 163
// module chunks = 1 2 3 5 7 8 9 11 13 14 16 17 18 19 20 21 25 26 28